import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { valueOf as e, exists as t } from "./get.js";
import { getProperties as r } from "./utils.js";
import { originSpecificReadPropertyDefinition as n, originSpecificPropertyDefinition as o } from "./extensions/serializableProperty.js";

function s(e, r, n) {
  if (!e || !e.read || !1 === e.read.enabled || !e.read.source) return !1;
  var o = e.read.source;

  if ("string" == typeof o) {
    if (o === r) return !0;
    if (o.indexOf(".") > -1 && 0 === o.indexOf(r) && t(o, n)) return !0;
  } else {
    var _iterator = _createForOfIteratorHelper(o),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _s = _step.value;
        if (_s === r) return !0;
        if (_s.indexOf(".") > -1 && 0 === _s.indexOf(r) && t(_s, n)) return !0;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return !1;
}

function i(e) {
  return e && (!e.read || !1 !== e.read.enabled && !e.read.source);
}

function a(e, t, r, o, a) {
  var f = n(t[r], a);
  i(f) && (e[r] = !0);

  var _iterator2 = _createForOfIteratorHelper(Object.getOwnPropertyNames(t)),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _i = _step2.value;
      f = n(t[_i], a), s(f, r, o) && (e[_i] = !0);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
}

function f(e, t, r, n) {
  var s = r.metadatas,
      i = o(s[t], "any", n),
      a = i && i.default;
  if (void 0 === a) return;
  var f = "function" == typeof a ? a.call(e, t, n) : a;
  void 0 !== f && r.set(t, f);
}

var c = {
  origin: "service"
};

function u(t, o) {
  var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : c;
  if (!o || "object" != typeof o) return;
  var i = r(t),
      u = i.metadatas,
      d = {};

  var _iterator3 = _createForOfIteratorHelper(Object.getOwnPropertyNames(o)),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _e2 = _step3.value;
      a(d, u, _e2, o, s);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  i.setDefaultOrigin(s.origin);

  var _iterator4 = _createForOfIteratorHelper(Object.getOwnPropertyNames(d)),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var _r = _step4.value;

      var _a = n(u[_r], s).read,
          _f = _a && _a.source;

      var _c = void 0;

      _c = _f && "string" == typeof _f ? e(o, _f) : o[_r], _a && _a.reader && (_c = _a.reader.call(t, _c, o, s)), void 0 !== _c && i.set(_r, _c);
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  if (!s || !s.ignoreDefaults) {
    var _iterator5 = _createForOfIteratorHelper(Object.getOwnPropertyNames(u)),
        _step5;

    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var _e = _step5.value;
        d[_e] || f(t, _e, i, s);
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  }

  i.setDefaultOrigin("user");
}

function d(e, t, r) {
  var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : c;
  var o;

  var s = _objectSpread(_objectSpread({}, n), {}, {
    messages: []
  });

  r(s), null == (o = s.messages) || o.forEach(function (t) {
    "warning" !== t.type || e.loaded ? n && n.messages && n.messages.push(t) : e.loadWarnings.push(t);
  });
}

export { u as default, u as read, d as readLoadable };